import Carousel from './carousel';

class Timeline {
    constructor(passedElement) {
        this.elem = passedElement;
        this.carousel = null;
        this.flkty = null;
    }

    init() {
        if (!this.elem) return this;

        this.carousel = new Carousel(this.elem, {
            cellSelector: '.timeline__slide',
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            pageDots: true,
            prevNextButtons: true,
            imagesLoaded: true,
            on: {
                ready: () => {
                    this.flkty = this.carousel?.flkty || this.carousel?.flickity || null;

                    this.setDotLabels();
                    this.bindDotSync();
                }
            }
        }).init();

        return this;
    }

    setDotLabels() {
        const slides = this.elem.querySelectorAll('.timeline__slide');
        const dots = this.elem.querySelectorAll('.flickity-page-dot');

        if (!slides.length || !dots.length) return;

        dots.forEach((dot, index) => {
            const label = slides[index]?.dataset.dotLabel;

            if (!label) return;

            dot.dataset.dotLabel = label;
        });
    }

    bindDotSync() {
        if (!this.flkty) return;

        // Flickity can rebuild dots on select/layout changes in some setups
        const update = () => {
            this.setDotLabels();
        };

        this.flkty.on('select', update);
        this.flkty.on('settle', update);
        this.flkty.on('reposition', update);
    }
}

export default Timeline;